var map = {
	"./blinds-1.jpg": 549,
	"./blinds-2.jpg": 298,
	"./curtain-1.jpg": 955,
	"./curtain-2.jpg": 676,
	"./curtain-3.jpg": 102,
	"./mosquito-net-door-1.jpg": 349,
	"./mosquito-net-door-2.jpg": 858,
	"./mosquito-net-door-3.jpg": 855,
	"./mosquito-net-windows-1.jpg": 198,
	"./mosquito-net-windows-2.jpg": 617,
	"./wallpaper-1.jpg": 671,
	"./wallpaper-2.jpg": 672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 119;